// extracted by mini-css-extract-plugin
export default {"button":"src-pages-SalesChannelContentEditor-SalesChannelEditorButton-Preview-Button-style__button--UrehF"};